import React from 'react';
import { BulletPointContainer, BulletPointIndex, TriangleDown } from './styles';
var BulletPointBox = function (_a) {
    var index = _a.index, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor, borderRadius = _a.borderRadius, bulletPointBackgroundColor = _a.bulletPointBackgroundColor, children = _a.children;
    return (React.createElement(BulletPointContainer, { backgroundColor: backgroundColor, borderColor: borderColor, borderRadius: borderRadius },
        React.createElement(BulletPointIndex, { bulletPointBackgroundColor: bulletPointBackgroundColor },
            React.createElement("span", null, index),
            React.createElement(TriangleDown, { bulletPointBackgroundColor: bulletPointBackgroundColor })),
        children));
};
export default BulletPointBox;
